import type { UserField } from './types';

export interface FieldDefinition {
  key: UserField;
  label: string;
  required: boolean;
  aliases: string[];
}

export const USER_FIELDS: FieldDefinition[] = [
  {
    key: 'email',
    label: 'Email',
    required: true,
    aliases: ['email', 'e-mail', 'emaili', 'mail'],
  },
  {
    key: 'firstName',
    label: 'Emri',
    required: true,
    aliases: ['emri', 'first_name', 'firstname', 'name', 'first name', 'emri i pare'],
  },
  {
    key: 'lastName',
    label: 'Mbiemri',
    required: true,
    aliases: ['mbiemri', 'last_name', 'lastname', 'surname', 'last name'],
  },
  {
    key: 'password',
    label: 'Fjalekalimi',
    required: false,
    aliases: ['password', 'fjalekalimi', 'fjalekalim', 'pass'],
  },
  {
    key: 'role',
    label: 'Roli',
    required: false,
    aliases: ['roli', 'role', 'pozita', 'tipi'],
  },
  {
    key: 'phone',
    label: 'Telefoni',
    required: false,
    aliases: ['telefoni', 'phone', 'tel', 'nr', 'numri', 'celular'],
  },
  {
    key: 'position',
    label: 'Pozicioni',
    required: false,
    aliases: ['pozicioni', 'position', 'detyra', 'funksioni'],
  },
];

export const STEP_LABELS = ['Ngarko CSV', 'Lidh Kolonat', 'Importo'] as const;

export const STRINGS = {
  wizardTitle: 'Importo Perdorues nga CSV',
  uploadTitle: 'Ngarko skedarin CSV',
  uploadDesc: 'Zvarrit skedarin ketu ose kliko per ta zgjedhur',
  uploadAccept: 'Formati i pranuar: .csv',
  previewTitle: 'Parashikim',
  mappingTitle: 'Lidh kolonat e CSV me fushat e perdoruesit',
  mappingIgnore: 'Injoro',
  mappingRequired: 'E detyrueshme',
  importTitle: 'Opsionet e importit',
  sendEmail: 'Dergo email mireseardhje perdoruesve',
  autoPassword: 'Gjenero fjalekalime automatikisht',
  defaultRole: 'Roli i parazgjedhur',
  defaultStatus: 'Statusi i parazgjedhur',
  importing: 'Duke importuar...',
  btnContinue: 'Vazhdo',
  btnBack: 'Prapa',
  btnImport: 'Importo',
  btnClose: 'Mbyll',
  errors: 'gabime',
  warnings: 'paralajmerime',
  successCount: 'te suksesshem',
  failedCount: 'te deshtuar',
  noFile: 'Asnje skedar i zgjedhur',
  invalidFile: 'Skedari nuk eshte CSV i vlefshem',
  emptyFile: 'Skedari eshte bosh',
  fileTooLarge: 'Skedari eshte shume i madh (max 5MB)',
  requiredFieldsMissing: 'Fushat e detyrueshme nuk jane lidhur',
  rowErrors: 'Ka rreshta me gabime',
  importComplete: 'Importimi perfundoi',
  usersToImport: 'perdorues per import',
} as const;
